import { state } from './models';
import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';

export const reportingCoreModule = {
  state,
  getters,
  actions,
  mutations,
};
